// 영웅별 스킬 타임라인 고르기(c022). 게임 로직·HUD·렌더가 지금 영웅의 표를 이 함수로 고른다(카엘 데이터는 kael.ts 그대로).
// C10-5: 카엘은 전직 갈래(job 0 블러드 버서커 · 1 소드 마스터)에 따라 9·10번(전직 스킬)이 다르다. job을 안 주면 0번 갈래 표(전직 전에는 9·10이 잠겨 있다)
// C10-6: 라이라도 갈래(0 윈드 스나이퍼 · 1 트랩 레인저)에 따라 12·13번이 다르다(1..11은 같다)
import { KAEL_SKILLS_BY_JOB } from './kael';
import { LYRA_SKILLS_BY_JOB } from './lyra';
import type { SkillHeroId, SkillTimeline } from './types';

export const SKILLS_BY_HERO: Readonly<Record<SkillHeroId, readonly SkillTimeline[]>> = { kael: KAEL_SKILLS_BY_JOB[0], lyra: LYRA_SKILLS_BY_JOB[0] };

/** 영웅의 스킬 타임라인 표(스킬 번호 n = 표[n-1]). 모르는 영웅은 카엘 */
export function heroSkills(hero: SkillHeroId | undefined, job: 0 | 1 = 0): readonly SkillTimeline[] {
  if (hero === 'lyra') return LYRA_SKILLS_BY_JOB[job === 1 ? 1 : 0];
  return KAEL_SKILLS_BY_JOB[job === 1 ? 1 : 0];
}
